import React from "react";
import OrderManager from "../../components/orders/OrderManager";
import "../../styles/pages/TallerPage.css";

function TallerPage() {
  return (
    <div className="taller-page">
      <div className="mb-3">
        <h2>🔧 Gestión de Taller</h2>
        <p className="text-muted">
          Gestiona los pedidos en taller, cambia estados y controla la producción
        </p>
      </div>
      
      {/* Renderizar el OrderManager completo para que taller tenga todas las funcionalidades */}
      <OrderManager />
    </div>
  );
}

export default TallerPage;
